
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.971 4.27a.635.635 0 110-1.27h6.394c.352 0 .635.283.635.635v6.505a.635.635 0 11-1.27 0V5.137l-4.78 4.78a.636.636 0 01-.9-.898l4.753-4.75H9.971z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M3 3.635C3 3.283 3.283 3 3.635 3h4.444a.635.635 0 110 1.27H4.27v11.46h11.46v-3.85a.635.635 0 111.27 0v4.485a.633.633 0 01-.635.635H3.635A.633.633 0 013 16.365V3.635z","fill":"currentColor"}})])
          )
        }
      }
    